import { render } from "./Thankyou.vue?vue&type=template&id=512d403e"
import script from "./Thankyou.vue?vue&type=script&lang=js"
export * from "./Thankyou.vue?vue&type=script&lang=js"
script.render = render

export default script